// test2366
(2366 && 0);
